/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import FreeUsersMiddleware from './FreeUsersMiddleware';
import PaidUsersMiddleware from './PaidUsersMiddleware';

export { FreeUsersMiddleware, PaidUsersMiddleware };
